<template>
  <div>
    <div class="row">
      <!-- <div class="col-4" style="max-width: 300px;">
        <label for="select-indicator">
          {{ this.$t('reports.indicators.indicatorLabel') }}:
        </label>
        <b-form-select
          v-model="indicatorSelected"
          id="select-indicator"
          :options="indicatorLabels"
          @change="selectIndicator(null)"
        ></b-form-select>
      </div> -->

      <div class="col-3">
        <label class="">Tipo de análise</label>
        <b-form-radio-group
          id="type-radio-group"
          name="type-radio"
          :value="analysisType"
          v-model="analysisType"
          @change="selectIndicator($event)"
        >
          <b-form-radio name="answer-radio" value="answer"
            >Resposta</b-form-radio
          >
          <b-form-radio name="invite-radio" value="invite"
            >Convite</b-form-radio
          >
        </b-form-radio-group>
      </div>

      <!-- <div class="col-3" style="max-width: 300px;">
        <label for="select-order">
          Ordenar por:
        </label>
        <b-form-select
          v-model="orderSelected"
          id="select-order"
          @change="selectOrder($event)"
        >
          <b-form-select-option
            v-for="(item, i) in orderOptions"
            :key="i"
            :value="item"
            >{{ item.field }}
          </b-form-select-option>
        </b-form-select>
      </div> -->
    </div>

    <div v-if="loader" class="row mb-4">
      <div class="col-12 text-center">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
    </div>

    <div v-else-if="this.items.length > 0">
      <div class="row mt-4">
        <div class="col-12">
          <b-table
            id="table-indicators"
            striped
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :fields="fields"
            :items="items"
            :per-page="perPage"
            :busy="loading"
            :current-page="currentPage"
          >
            <template v-slot:cell(corporateName)="row">
              {{ row.item.corporateName }}
            </template>
            <template v-slot:cell(lastDate)="row" class="max-td">
              {{ formatDate(row.item.lastDate) }}
            </template>
            <template v-slot:cell(days)="row" class="max-td">
              {{ row.item.days }}
            </template>
          </b-table>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mt-4 mb-4">
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              aria-controls="table-indicators"
            ></b-pagination>
          </div>
        </div>
        <div class="col-6 mt-2 text-right">
          <a
            @click="exportToXLS"
            :title="`${this.$t('reports.exportXlsLabel')}`"
          >
            <span class="xls">
              <i class="fas fa-file-download"></i>
            </span>
          </a>
        </div>
        <!-- <div class="col-6 mt-2 text-right">
          <div>
            <div
              v-if="loadingDownloadIconXls"
              class="text-center text-primary my-2"
            >
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
            <a v-else @click="exportData('xlsx')" title="Exportar para XLS">
              <span class="xls">
                <i class="fas fa-file-excel"></i>
              </span>
            </a>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div v-else-if="this.items.length === 0" class="row mt-4">
      <div class="col-12 text-center">
        <p>
          <font-awesome-icon
            :icon="['fas', 'folder-open']"
            style="margin-right: 20px; font-size: 35px;"
          />
        </p>
        <h5>
          {{ this.$t('reports.indicators.noDatalabel') }}
        </h5>
        <p>
          {{ this.$t('reports.indicators.noAnswerLabel') }}
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
import swal from 'sweetalert';
import XLSX from 'xlsx';
import { lightFormat } from 'date-fns';
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import Paginate from 'vuejs-paginate';
import api from '@/services/api';

export default {
  name: 'SurveysInvites',
  components: {
    RadialProgressBar,
    animatedNumber,
    Paginate,
  },

  data: () => ({
    analysisType: 'answer',
    loadingDownloadIconXls: false,
    userAuth: null,
    visible: true,
    loader: false,
    loading: false,
    vendasScore: null,
    posvendasScore: null,
    indicatorSelected: null,
    indicatorSelectedLabel: '',
    indicatorLabels: [],
    fields: [],
    sortBy: '',
    sortDesc: true,
    search: null,
    items: [],
    keepItems: [],
    total: 0,
    currentPage: 1,
    perPage: 50,
    firstDisplayed: true,
    chartPromoters: '',
    chartPassives: '',
    chartDetrators: '',
    metricLabel: '',
    totalSteps: 100,
  }),
  methods: {
    async getIndicators() {
      this.indicatorSelected = null;
      this.indicatorLabels = [
        {
          value: null,
          text: this.$t('reports.indicators.selIndicatorSelectLabel'),
        },
      ];

      const response = await api.get(
        `indicators/distinct/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            groupId: this.actionGroupData._id,
            metric: this.myMetric ? this.myMetric : null,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          },
        },
      );

      response.data.indicators.forEach((indicator) => {
        this.indicatorLabels.push({
          value: indicator.key,
          text: indicator.text,
        });
      });
    },
    updateTable() {
      this.selectIndicator(null);
    },
    async selectIndicator(ev) {
      this.loader = true;
      this.firstDisplayed = false;

      let label;
      if (ev) {
        if (ev === 'answer') {
          label = 'resposta';
        }
        if (ev === 'invite') {
          label = 'convite';
        }
      } else {
        if (this.analysisType === 'answer') {
          label = 'resposta';
        }
        if (this.analysisType === 'invite') {
          label = 'convite';
        }
      }

      this.fields = [
        {
          key: 'corporateName',
          label: 'Filial', // `${this.indicatorSelectedLabel}`,
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'lastDate',
          label: `Data ult. ${label}`,
          sortable: false,
          class: 'text-center max-td',
        },
        {
          key: 'days',
          label: `Dias sem ${label}`,
          sortable: false,
          class: ['text-center', 'max-td'],
        },
      ];

      const response = await api.get(`reports/show-days`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          analysisType: ev ? ev : this.analysisType,
          // actionId: this.myActionId !== '0' ? this.myActionId : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          // metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
        },
      });

      this.items = response.data.data;
      this.total = response.data.total;
      this.loader = false;
    },
    changeLabel() {
      if (this.myMetric.indexOf('nps') !== -1) {
        this.chartPromoters = this.$t('reports.promoterLabel');
        this.chartPassives = this.$t('reports.neutralLabel');
        this.chartDetrators = this.$t('reports.detractorLabel');
        this.metricLabel = this.$t('reports.npsLabel');
        this.totalSteps = 100;
      } else if (this.myMetric.indexOf('ces') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = this.$t('reports.cesLabel');
        this.totalSteps = 5;
      } else if (this.myMetric.indexOf('csat') !== -1) {
        this.chartPromoters = '4-5';
        this.chartPassives = '3';
        this.chartDetrators = '1-2';
        this.metricLabel = 'CSAT';
        this.totalSteps = 100;
      }
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    async exportToXLS() {
      const label = this.analysisType === 'answer' ? 'resposta' : 'convite';

      const response = await api.get(`reports/show-days`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          analysisType: this.analysisType,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
        },
      });

      const items = response.data.data;

      const header = ['Filial'];

      const arr = [];
      items.forEach((a) => {
        arr.push({
          Filial: a.corporateName,
          [`Data ult. ${label}`]: this.formatDate(a.lastDate),
          [`Dias sem ${label}`]: a.days,
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('indicadores');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      wb.Sheets.indicadores = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', `monitoramento_${label}.xlsx`);
      document.body.appendChild(link);
      link.click();
    },
    async exportData(type) {
      // checks if the total docs to download is greater then 100k
      if (this.total > 100000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }
      if (type === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else {
        this.loadingDownloadIconCsv = true;
      }

      try {
        await api.post(`reports/download/${this.userAuth.companyId}/${type}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            analysisType: this.analysisType,
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myIh2 === '0' ? null : this.myIh2,
            metric: this.myMetric ? this.myMetric : null,
            groupId: this.actionGroupData._id,
          },
        });

        swal({
          title: this.$t('answers.donwload.title'),
          text: this.$t('answers.donwload.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('answers.ops'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },
    formatDate(actionDate) {
      return lightFormat(new Date(actionDate), 'dd/MM/yyyy');
    },
  },
  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabel();
    this.fields = [
      {
        key: 'corporateName',
        label: 'Filial', // `${this.indicatorSelectedLabel}`,
        sortable: true,
        class: 'text-left',
      },
      {
        key: 'lastDate',
        label: 'Data ult. resposta/convite',
        sortable: false,
        class: 'text-center max-td',
      },
      {
        key: 'days',
        label: 'Dias sem resposta/convite',
        sortable: false,
        class: ['text-center', 'max-td'],
      },
    ];
    this.indicatorLabels = [
      {
        value: null,
        text: this.$t('reports.indicators.selIndicatorSelectLabel'),
      },
    ];
  },
  async mounted() {
    await this.getIndicators();
    await this.selectIndicator();
  },
  watch: {
    actionGroupData: async function watchActionGroupData() {
      await this.selectIndicator();
    },

    myActionId: async function watchMyActionId() {
      await this.selectIndicator();
    },

    myActionsIds: async function watchMyActionsIds() {
      await this.selectIndicator();
    },

    myIh1: async function watchMyIh1() {
      await this.selectIndicator();
    },

    myHierarchies1: async function watchMyHierarchies1() {
      await this.selectIndicator();
    },

    myIh2: async function watchMyIh2() {
      await this.selectIndicator();
    },

    myHierarchies2: async function watchMyHierarchies2() {
      await this.selectIndicator();
    },

    items: function watchItems() {
      // this.total = this.items.length;
    },

    calendarDates: async function watchDates() {
      await this.selectIndicator();
    },

    myMetric: async function watchMyMetric() {
      this.changeLabel();
      await this.getIndicators();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.selectIndicator();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.selectIndicator();
    },
    indicatorSelected: async function watchindIcatorSelected() {
      this.currentPage = 1;
    },
    analysisType: async function watchindAnalysisType() {
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.cards {
  border-radius: 4px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom-color: none;
  position: relative;
  height: 65px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}

.pagination-area-config-users >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>
<style>
.pagination-area-config-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-config-users a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/surveys-invites/index.vue